import { useQuery } from "@tanstack/react-query";
import { getHealthReports } from "../api/health-report.api";

export const healthKeys = {
  all: ["admin-member-health-reports"] as const,
  list: (memberId: number) =>
    [...healthKeys.all, "list", memberId] as const,
};

export const useHealthReports = (memberId: number) => {
  return useQuery({
    queryKey: healthKeys.list(memberId),
    queryFn: () => getHealthReports(memberId),
    enabled: !!memberId,
    select: (data) =>
      [...data].sort(
        (a, b) =>
          new Date(a.created_at).getTime() - new Date(b.created_at).getTime(),
      ),
    staleTime: 60 * 1000 * 5, // 5 minutes
    gcTime: 60 * 60 * 1000, // 1 hour
  });
};
